<!--
 * @Author: linhao hao.lin@biz-united.com.cn
 * @Date: 2026-01-15 17:07:18
 * @LastEditors: linhao hao.lin@biz-united.com.cn
 * @LastEditTime: 2026-01-15 17:26:40
 * @FilePath: \crm-product\found\views\cps\views\rights\fee\dealer_no_invoice_fee\dealer_no_invoice_fee.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<script>
import TablePage from '@/found/components/table_page';
import request from '@/found/utils/request';
import Form from './form';

export default {
  name: 'modules',
  extends: TablePage,
  components: {
    Form,
  },
  data() {
    return {
      requestType: 'GET',
      requestUrl: '/cps-mobile/consumerdynamicredpacket/queryPage',
      params: {
      },
      formConfig: {
        code: 'view',
      },
      modalConfig: {},
    };
  },
  async created() {
    await this.getConfigList('main_list');
  },
  methods: {
    modalClick({ val, row }) {
      this.modalConfig = {
        title: '经销商不开票费用报表明细',
      };
      switch (val.code) {
        case 'detail':
          this.formName = 'Form';
          this.formConfig.row = row;
          this.formConfig.code = 'view';
          this.openFull();
          break;
        default:
          break;
      }
    },
  },
};
</script>
